import React, { FC } from 'react';
import { MessageDescriptor, useIntl } from 'react-intl';
import { NavLink } from 'react-router-dom';
import { alpha, makeStyles, Theme } from '@material-ui/core';
import classNames from 'classnames';
import { SVGIcon } from 'types/common.types';
import useSidebarContext from 'common/hooks/context/useSidebarContext';
import SidebarIcon from 'components/Sidebar/SidebarIcon';
import SidebarTooltip from 'components/Sidebar/SidebarTooltip';

const useStyles = makeStyles((theme: Theme) => ({
  navLink: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '12px',
    width: '100%',
    padding: '10px 14px',
    borderRadius: '4px',
    color: 'white',
    position: 'relative',
    whiteSpace: 'nowrap',
    '&:hover': {
      backgroundColor: alpha(theme.palette.secondary.main, 0.7),
    },
    '&.active': {
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.main,
      },
    },
  },
  navLinkText: {
    fontSize: '14px',
    fontWeight: 400,
  },
  navLinkTextRoot: {
    fontWeight: 700,
  },
}));

interface ISideBarNavLink {
  id: string;
  to: string;
  title: MessageDescriptor;
  icon?: SVGIcon;
  iconViewBox?: string;
  displayTitle?: boolean;
  displayTooltip?: boolean;
}

const SideBarNavLink: FC<ISideBarNavLink> = ({
  id,
  to,
  title,
  icon,
  iconViewBox = '0 0 20 20',
  displayTitle = false,
  displayTooltip = false,
}) => {
  const classes = useStyles();
  const intl = useIntl();
  const { sidebarOpen } = useSidebarContext();
  const translatedTitle = intl.formatMessage(title);

  return (
    <NavLink id={id} to={to} className={classNames('sidebarNavLink', classes.navLink)}>
      {icon ? <SidebarIcon icon={icon} iconViewBox={iconViewBox} /> : null}

      {sidebarOpen || displayTitle ? (
        <div
          className={classNames('sidebarNavLinkText', classes.navLinkText, {
            [classes.navLinkTextRoot]: !!icon,
          })}
        >
          {translatedTitle}
        </div>
      ) : null}

      {!sidebarOpen && displayTooltip ? <SidebarTooltip title={translatedTitle} /> : null}
    </NavLink>
  );
};

export default SideBarNavLink;
